import { Plugin, registerPlugin } from '@capacitor/core';

type FacebookEventType = {
  amount: number;
  currency: string;
  contentID: string;
  contentType: string;
};

export interface FacebookSDKPlugin extends Plugin {
  logViewedContent(options: FacebookEventType): Promise<void>;
  logAddedToCart(options: FacebookEventType): Promise<void>;
  logPurchase(options: FacebookEventType): Promise<void>;
  logSignUp(): Promise<void>;
}

const FacebookSDKPlugin =
  registerPlugin<FacebookSDKPlugin>('FacebookSDKPlugin');

export default FacebookSDKPlugin;
